const FriendRankMergeList = require("./FriendRankMergeList");
const ListViewLeft = require("./ListViewLeft");
const itemHeight = 137;
const itemWidth = 108;

/** 关前/关末 关卡 好友/勋章 排行榜 */
let MedalRankList = xClass("MedalRankList", BasePanel, function () {
    return cc.CSLoader.createNode("cocos/start_start_rank.csb");
})

MedalRankList.prototype.ctor = function (levelId, data, params = {}, subCategory = "") {
    let self = this;
    self.levelId = levelId;
    self.data = data;
    if (params && params.pf) {
        delete params.pf;
    }
    self.params = params;
    self.subCategory = subCategory;
    self.initUI();

    //打开勋章排行榜时关闭关卡榜，防止drawcall过高
    self._kMedalRankOpen = function (event) {
        let show = true;
        if (event.data && event.data.show == true) {
            show = false;
        }
        self.setVisible(show);
        let parent = self.getParent();
        if (parent) {
            parent.setVisible(show);
        }
    }
    GlobalEventDispatcher.getInstance().addEventListener(
        kGlobalEvents.kMedalRankOpen,
        self._kMedalRankOpen,
    );
}

MedalRankList.prototype.initUI = function () {
    let self = this;
    //
    self.back = self.getChildByName("back");
    self.type1 = self.getChildByName("type1");
    self.type2 = self.getChildByName("type2");
    self.emptyBg = self.getChildByName("start_rank_no");
    self.back.setLocalZOrder(99);
    //
    self.nodepool = [];
    //
    quickBuildUIButton(self.back, () => {
        if (self.isBusy) return;
        self.listView.refresh(0);
        self.back.setVisible(false);
    })
    quickBuildUIButtonNoAction(self.type1.getChildByName("normal"), () => {
        if (self.isBusy || !self.friendType) return;
        self.showTab(1);
        self.refreshTab(1);
        self.isDcSlide = false;
        self.dcRankClick("friend_rank");
    })
    quickBuildUIButtonNoAction(self.type2.getChildByName("normal"), () => {
        if (self.isBusy || !self.showMedal) return;
        self.showTab(2);
        self.refreshTab(2);
        self.isDcSlide = false;
        self.dcRankClick("global_rank");
    })
    //是否打点过滑动
    self.isDcSlide = false;
    //创建列表
    let scrollView = ListViewLeft.create(self);
    scrollView.setBounceEnabled(true);
    scrollView.setContentSize(display.width - 110, itemHeight);
    scrollView.setPosition(-display.width / 2, -itemHeight / 2 + 5);
    self.addChild(scrollView);
    self.listView = scrollView;
    self.listView.setSwallowTouches(true);
    scrollView.addEventListener(function (view, event) {
        if (event == ccui.ScrollView.EVENT_CONTAINER_MOVED) {
            if (self.listData.length > 5 && scrollView.getInnerContainer().x < -itemWidth + 30) {
                self.back.setVisible(true);
            }
            if (!self.isDcSlide) {
                self.isDcSlide = true;
                let click_type = self.curTab == 1 ? "friend_rank_check" : "global_rank_check";
                self.dcRankClick(click_type);
            }
        }
    })
    //
    self.friendType = UserManager.getInstance().getFriendRankType();
    self.showMedal = UserManager.getInstance().supportMedal();
    console.log(self.friendType, self.showMedal, self.data);
    //抖音开发者工具无法展示开放域
    if(window.mini && mini.getPlatform() == MiniPlatform.tt && mini.isDevTool()){
        self.friendType = 0;
    }
    if (!self.friendType || !self.showMedal || !self.data || !$len(self.data.rankList)) {
        self.type1.getChildByName("normal").setVisible(false);
        self.type1.getChildByName("selected").setVisible(false);
        self.type2.getChildByName("normal").setVisible(false);
        self.type2.getChildByName("selected").setVisible(false);
        self.showMedal = false;
    }
    //已加载头像数据玩家数量
    self.hasUserShowCount = 0;
    let type = 1;
    if (self.data) {
        if (self.data.rank > 0 || !self.friendType) {
            type = 2;
        }
        let rankList = self.data.rankList;
        if (rankList && rankList[1]) {
            let user = UserManager.getInstance().getUserRef();
            let profile = UserManager.getInstance().getProfileRef();
            let scoreRef = UserManager.getInstance().getUserScore(self.levelId);
            let myRank = {
                uid: user.uid,
                value: scoreRef ? scoreRef.score : 0,
                rank: self.data.rank,
                avatar: profile.headUrl,
                nickname: user.name,
                userShow: DressManager.getInstance().getInUse(),
            };

            rankList = rankList.slice(1);
            if (self.data.topRankUserProfileList && $len(self.data.topRankUserProfileList)) {
                self.addUserShowToList(rankList, self.data.topRankUserProfileList, 0);
            }
            if (self.data.lastRankUserProfileList && $len(self.data.lastRankUserProfileList)) {
                self.addUserShowToList(rankList, self.data.lastRankUserProfileList, rankList.length - $len(self.data.lastRankUserProfileList));
            }
            self.medalRankData = {
                myRank,
                rankList,
            }
        }
    }

    self.back.setVisible(false);
    self.showTab(type);
    self.refreshTab(type);
}

//1.好友榜单 2.勋章全国榜
MedalRankList.prototype.showTab = function (showTab) {
    let self = this;
    self.curTab = showTab;
    self.listData = [];
    //清空状态
    self.hideInteractionBtn();
    self.hideMyRankItem();
    self.listView.setVisible(false);
    self.emptyBg.setVisible(true);
    self.back.setVisible(false);
    if (showTab == 1) {
        if (self.friendType == 2) {
            function onSuccess(list) {
                if (list && list[1]) {
                    let rank = 1;
                    let myRank = null;
                    const uid = UserManager.getInstance().uid;
                    for (let i = 1; i < list.length; i++) {
                        let temp = list[i];
                        if (temp && temp.score && temp.profile) {
                            let data = {
                                uid: temp.score.uid,
                                value: temp.score.score,
                                rank,
                                avatar: temp.profile.headUrl,
                                nickname: temp.profile.name,
                                extra: temp,
                            }
                            if (data.uid == uid) {
                                myRank = data;
                            }
                            self.listData.push(data);
                            rank++;
                        }
                    }
                    self.listView.setVisible(true);
                    self.listView.refresh(0);
                    //
                    if (myRank) {
                        self.showMyRankItem(myRank);
                    }
                    self.emptyBg.setVisible(false);
                }
            }
            function onFail() {

            }
            UserRank.getInstance().getFriendRank(self.levelId, onSuccess, onFail)
        } else if (self.friendType == 1) {
            self.emptyBg.setVisible(false);
            if (!self.openDataContext) {
                let rank = FriendRankMergeList.create(table([1, "levelId", self.levelId], [1, "rankType", 1]), self)
                self.addChild(rank);
                let posY = 185;
                // if (cc.sys.os === cc.sys.OS_IOS && display.height / display.width > 1.78) {
                //     posY += 20;
                // }
                rank.setPosition(-display.width / 2, posY);
                self.openDataContext = rank;
            } else {
                self.openDataContext.setVisible(true);
            }
        }
    }
    else if (showTab == 2) {
        self.openDataContext && self.openDataContext.setVisible(false);
        //
        if (self.medalRankData) {
            self.emptyBg.setVisible(false);
            self.listData = self.medalRankData.rankList;
            self.listView.setVisible(true);
            self.listView.refresh(0);
            self.showMyRankItem(self.medalRankData.myRank);
            //拉取玩家排行附近的玩家装扮
            if (temp.rank && temp.rank < self.listData.length) {
                self.getUserShow(temp.rank);
            }
        }
    }
}

//刷新上方tab按钮
MedalRankList.prototype.refreshTab = function (showTab) {
    let self = this;
    if (self.friendType && self.showMedal) {
        self.type1.getChildByName("selected").setVisible(showTab == 1);
        self.type2.getChildByName("selected").setVisible(showTab == 2);
    }
    self.type2.getChildByName("bg").setVisible(showTab == 2);
}
//在右边展示一个自己的节点
MedalRankList.prototype.showMyRankItem = function (data) {
    let self = this;
    let item = self.myRankItem;
    if (!item) {
        item = self.getItem();
        item.setPosition(display.width / 2 - item.width, -3)
        self.addChild(item);
        self.myRankItem = item;
        quickBuildUIButtonNoAction(item, () => {
            if (self.isBusy) return;
            if (self.listData && self.listData.length && self.myRankData) {
                let focusIndex = self.listData.length;
                if (self.myRankData.rank && self.myRankData.rank < self.listData.length) {
                    focusIndex = self.myRankData.rank;
                }
                self.listView.refresh(focusIndex - 1);
                self.back.setVisible(false);
            }
        })
    }
    item.initData(data, self.curTab);
    item.setVisible(true);
    self.myRankData = data;
}

//隐藏右边自己的节点
MedalRankList.prototype.hideMyRankItem = function () {
    let self = this;
    if (self.myRankItem) {
        self.myRankItem.setVisible(false);
    }
}

//展示好友授权按钮
MedalRankList.prototype.showInteractionBtn = function () {
    let self = this;
    if (!AuthorizeMgr.isAuthorizeByScope("FriendInteraction") && AuthorizeMgr.is_check_anthorize_start_level == 1) {
        if (!self.btnOpenSetting) {
            self.btnOpenSetting = cc.Sprite.createWithSpriteFrameName("level_difficulty/btn_data.png")
            self.addChild(self.btnOpenSetting);
            self.btnOpenSetting.setPosition(0, 0);

            quickBuildUIButton(self.btnOpenSetting, () => {
                let doFunction = () => {
                    self.hideInteractionBtn();
                    self.showTab(1);
                }
                let failFunction = () => {
                    cc.log("授权失败")
                    Toast.make(getText("授权失败"));
                }
                AuthorizeMgr.showAuthorizeGuidePanel(() => {
                    AuthorizeMgr.openSetting("FriendInteraction", doFunction, failFunction)
                }, () => {
                    Toast.make(getText("授权失败"));
                })
            })
        }
        self.btnOpenSetting.setVisible(true);
    }
}
//展示好友授权按钮
MedalRankList.prototype.hideInteractionBtn = function () {
    let self = this;
    self.btnOpenSetting && self.btnOpenSetting.setVisible(false);
}

MedalRankList.prototype.delegate_getLength = function () {
    let self = this;
    return self.listData ? self.listData.length : 0;
}

MedalRankList.prototype.delegate_getItemHeight = function (index) {
    return itemWidth;
}

MedalRankList.prototype.delegate_renderItem = function (index, itemView) {
    let self = this;
    if (itemView == null) {
        itemView = self.getItem();
    }
    let itemData = self.listData && self.listData[index];
    if (itemData) {
        itemView.initData(itemData, self.curTab);
    }
    self.getUserShow(index);
    return itemView;
}

MedalRankList.prototype.getItem = function () {
    let self = this;
    let item = null;
    if (self.nodepool && self.nodepool.length) {
        item = self.nodepool.pop();
    } else {
        const MedalRankItem = require("./MedalRankItem");
        item = MedalRankItem.create();
    }
    return item;
}

MedalRankList.prototype.onCleanup = function () {
    let self = this;
    if (self.nodepool) {
        for (let i = 0; i < self.nodepool.length; i++) {
            if (self.nodepool[i]) {
                self.nodepool[i].removeFromParent(true);
            }
        }
        self.nodepool = null;
    }
    self.askList = [];
    self.listData = [];
    if (self.myRankItem) {
        self.myRankItem.removeFromParent(true);
        self.myRankItem = null;
    }
    self.medalRankData = null;
    self.data = null;
    self.myRankData = null;
    self.openDataContext = null;
    self.params = null;
    self.subCategory = null;

    if (self._kMedalRankOpen) {
        GlobalEventDispatcher.getInstance().removeEventListener(
            kGlobalEvents.kMedalRankOpen,
            self._kMedalRankOpen
        );
        self._kMedalRankOpen = null;
    }
}

//向list数据中添加装扮数据
MedalRankList.prototype.addUserShowToList = function (list, userShow, startIdx) {
    let self = this;
    if (list && userShow) {
        for (let i = 0; i < userShow.length; i++) {
            let data = userShow[i + 1];
            let temp = list[startIdx + i];
            if (data && temp && !temp.nickname) {
                temp.nickname = data.nickname;
                temp.avatar = data.avatar;
                temp.userShow = data.userShow;
                self.hasUserShowCount++;
            }
        }
    }
}

//提前获取对应玩家的头像信息等
MedalRankList.prototype.getUserShow = function (curIdx) {
    let self = this;
    if (self.curTab != 2) return;
    if (!self.askList) {
        //查询中的数组下标
        self.askList = [];
    }
    //需要兼容从中间断开的情况
    let uidList = [];
    let idxList = [];
    let min = Math.max(curIdx - 30, 0);
    let max = Math.min(curIdx + 30, self.listData.length - 1);
    for (let i = min; i < max; i++) {
        let temp = self.listData[i];
        if (temp) {
            if (!temp.nickname && self.askList.indexOf(temp.rank) == -1) {
                uidList.push({
                    uid: temp.uid,
                    robot: temp.robot,
                });
                idxList.push(temp.rank);
            }
        }
    }

    if (!uidList.length) return;
    //
    let force = !self.listData[curIdx].nickname;//强制刷新
    if (force || uidList.length > 20 || uidList.length > (self.listData.length - self.hasUserShowCount) / 2) {
        console.log("拉取玩家头像数据：", uidList, idxList);
        self.askList = self.askList.concat(idxList);
        //去除失败或者成功的情况
        let delUidList = function (arr) {
            for (let i = 0; i < arr.length; i++) {
                let idx = self.askList.indexOf(arr[i]);
                if (idx != -1) {
                    self.askList.splice(idx, 1);
                }
            }
        }
        //
        function onSuccess(evt) {
            if (evt && evt.data && evt.data.profileList) {
                let profileList = evt.data.profileList;
                //添加头像等数据，不考虑一部分玩家没返回的情况
                for (let i = 1; i < profileList.length; i++) {
                    let idx = idxList[i - 1] - 1;
                    let data = profileList[i];
                    let temp = self.medalRankData.rankList[idx];

                    if (data && temp && !temp.nickname) {
                        self.hasUserShowCount++;
                        temp.nickname = data.nickname;
                        temp.avatar = data.avatar;
                        temp.userShow = data.userShow;
                    }
                }
                self.addUserShowToItem();
            }
            delUidList(idxList);
        }
        let onFail = function (evt) {
            delUidList(idxList);
            Toast.make(curryQuickGetErrorText(evt.data));
        }
        let http = GetUserProfileInfoHttp.new()
        http.addEventListener(Events.kComplete, onSuccess);
        http.addEventListener(Events.kError, onFail);
        http.addEventListener(Events.kCancel, onFail);
        http.load(uidList);
    }
}

MedalRankList.prototype.addUserShowToItem = function () {
    let self = this;

    let children = self.listView.getChildren();
    for (let i = 0; i < children.length; i++) {
        let child = children[i];
        if (child && child.idx != undefined) {
            let temp = self.listData[child.idx];
            if (temp) {
                child.tryAddUserShow && child.tryAddUserShow(temp);
            }
        }
    }
}

MedalRankList.prototype.dcRankClick = function (click_type) {
    let self = this;
    self.params.click_type = click_type;
    MedalRankManager.getInstance().dcSimple(self.subCategory, self.params);
}

module.exports = MedalRankList;
